import React from "react";
import { NavLink } from "react-router-dom";
import { setBlurOff, setNavOff } from "../../store/slices/hostSlices";
import { useDispatch, useSelector } from "react-redux";
import { getFlags } from "../../store/thunks/hostActions";

const SideNavLink = ({ icon, label, link, active }) => {
    const {hostInfo} = useSelector((state) => {
        return state.host;
    });

    const dispatch = useDispatch();

    return (
        <NavLink
            to={`/${link}`}
            onClick={(e) => {
                dispatch(setNavOff())
                dispatch(setBlurOff())
                dispatch(getFlags(hostInfo._id));
            }}
            className={({ isActive }) => 
                `flex items-center gap-3 px-4 py-3 mx-2 rounded-xl transition-all duration-300 group ${
                    isActive 
                        ? 'bg-gradient-to-r from-primary-50 to-primary-100 text-primary border-l-4 border-primary shadow-sm' 
                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                }`
            }
        >
            {({ isActive }) => (
                <>
                    <div className={`p-2 rounded-lg transition-all duration-200 ${
                        isActive
                            ? 'bg-gradient-to-br from-primary-500 to-primary-600 shadow-md shadow-primary-500/20'
                            : 'bg-gradient-to-br from-gray-200 to-gray-300 group-hover:from-primary-400 group-hover:to-primary-500 group-hover:shadow-md group-hover:shadow-primary-500/20'
                    }`}>
                        <img
                            src={icon}
                            alt={`${label} icon`}
                            className={`w-5 h-5 ${isActive ? 'brightness-0 invert' : 'opacity-70 group-hover:brightness-0 group-hover:invert'}`}
                        />
                    </div>
                    <span className="font-medium text-sm">{label}</span>
                </>
            )}
        </NavLink>
    );
};

export default SideNavLink;
